<template>
  <div class="login">
    <MenuLogo class="logo"/>
    <el-card>
      <h2>Login</h2>
      <el-form
        class="login-form"
        :model="model"
        :rules="rules"
        ref="form"
        @submit.native.prevent="login"
      >
        <el-form-item prop="username">
          <el-input
            v-model="model.username"
            placeholder="Username"
            prefix-icon="fas el-icon-fa-user"
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="model.password"
            placeholder="Password"
            prefix-icon="fas el-icon-fa-lock"
            show-password
          />
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loading"
            class="login-button"
            type="primary"
            native-type="submit"
            block
          >Login</el-button>
        </el-form-item>
        <div class="forgot-password">
          <el-link type="primary" href="mailto:po@drhttp.com">Forgot password ?</el-link>
        </div>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import { AUTH_REQUEST } from "@/store/actions/auth.js";

import MenuLogo from "@/components/MenuLogo.vue";

export default {
  components: {
    MenuLogo
  },
  data: function() {
    return {
      model: {
        username: this.$route.params.isDemo ? "demo" : "",
        password: this.$route.params.isDemo ? "demodemo" : ""
      },
      loading: false,
      rules: {
        username: [
          { required: true, message: "Username is required", trigger: "blur" }
        ],
        password: [
          { required: true, message: "Password is required", trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    login: function() {
      this.loading = true;
      const { username, password } = this.model;
      this.$store
        .dispatch(AUTH_REQUEST, { username, password })
        .then(() => {
          this.loading = false;
          this.$message.success("Login successfull");
          this.$router.push({ name: "projects" });
        })
        .catch(error => {
          this.loading = false;
          this.$message.error("Username and/or password is invalid");
        });
    }
  }
};
</script>

<style scoped lang="sass">

.login
  background-color: $--menu-background-color
  height: 100%
  @include flex($h: center, $v: center)
  flex-direction: column

.logo
  margin-bottom: 20px

h2
  text-align: center
  @include padding($v: 10px)

.login-button
  width: 100%

.forgot-password
  text-align: right

  a
    font-size: 0.8em

</style>